// セレクションのコンテンツを表すクラス
export class LibraryContent {
  constructor(
    public id: number,
    public displayOrder: number,
    public contentsTitle: string,
    public contentsType: string,
    public thumbnailImage: string,
    public documentTotalPage: number, // 総ページ数
    public moviePlayTimeSec: number, // 動画再生時間
    public isUnread: boolean, // 未読フラグ
    public isComplete: boolean, // 完了フラグ
    public progress: number, // 視聴進捗率
    public publishStatus: string, // 公開ステータス

    // ディレクトリ向け
    public title: string, // タイトル
    public thumbnailKey: string, // サムネイルキー
    public directoryContents: LibraryContent[] = [], // 子コンテンツ

    // 以下はレスポンスに含まれないもの。
    public sortId: string, // ソート時に使用するID、コンテンツとディレクトリを区別せずにソートするためのもの
    public isDirectory: boolean = false, // ディレクトリかどうか
    public isOpenDirectory: boolean = false, // ディレクトリが開いているかどうか
    public tempChildren: LibraryContent[] = [], // 仮の子コンテンツ。ディレクトリを開いてないときに表示し、ドラッグ可能とするためのもの

    public isEdit: boolean = false, // 編集フラグ
    public isLimitedByPlanPrice: boolean = false, // プラン価格によって制限されているか（APIで取得ではなくプログラムで付与）
  ) {}
}

export const emptyLibraryContent = () =>
  new LibraryContent(0, 0, "", "", "", 0, 0, false, false, 0, "", "", "", [], "", false, false, [], false, false);

export const addLibraryContentSortId = (content: LibraryContent) => {
  if (content.isDirectory) {
    content.sortId = `D-${content.id}`;
    content.directoryContents.forEach(c => {
      c.sortId = `C-${c.id}`;
    });
  } else {
    content.sortId = `C-${content.id}`;
  }
  return content;
};
